import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { FieldContainer } from '../../common/ui/field/styled.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TooltipFieldWithLabelContainer = styled(FieldContainer)({
	marginTop: token('space.050'),
	minHeight: '26px',
});
